module.exports = __webpack_public_path__ + "static/media/1000.5bcf04a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/1000.mp3
// module id = hOpo
// module chunks = 1